export default __webpack_public_path__ + "static/media/clouds__big.6700f579.jpg";